import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
// import { Pagination, Form, FormControl, FormGroup, ButtonToolbar, Button, InputGroup } from 'react-bootstrap'
// import Select from 'react-select';
// import Moment from 'moment';
// import CKAutocomplete from '../../../component/element/CKAutocomplete';
// import FontAwesome from 'react-fontawesome';
// import DatePicker from '../../../component/element/DatePicker'
// import CkTimePicker from '../../../component/element/CkTimePicker'
import WorkdocStore from '../../../stores/WorkdocStore'
import {connect} from 'react-redux'
// var NotificationSystem = require('react-notification-system');

class WorkTimeRecord extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      data: [],
    }
  }

  // componentDidMount() {
  //   let that = this
  //   this.setState({loading:true})
  //   WorkdocStore.loadTimerecord(this.props.workNo,function(result) {
  //     that.setState({loading:false,data:result.data})
  //   })
  // }

  loadData(work_no){
    let that = this
    this.setState({loading:true})
    WorkdocStore.loadTimerecord(work_no,function(result) {
      that.setState({loading:false,data:result.data})
    })
  }

  renderRowData() {
    let {data} = this.state
    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={9}>{this.props.messages['No Data']}</td></tr>)
    } else {
      return(
        data.map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td>{item.first_name+' '+item.last_name}</td>
              <td>{item.nick_name}</td>
              <td className='text-center'>{item.position}</td>
              <td className='text-center'>{item.department}</td>
              <td className='text-center'>{item.scan_time.substring(0, 10)}</td>
              <td className='text-center'>{item.scan_time.substring(11)}</td>
              <td className='text-center'>{item.status_text}</td>
              <td>{item.remark}</td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    let {messages} = this.props
  	return(
  	  <div className='display-overflow'>
  	    <table className='table table-responsive table-hover table-bordered-solid'>
  	      <thead>
  	        <tr>
  	          <th className='text-center' style={{width:'50px'}}>{messages['No']}</th>
  	          <th className='text-center' style={{width:'300px'}}>{messages['Fullname']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Nickname']}</th>
              <th className='text-center' style={{width:'120px'}}>{messages['Position']}</th>
              <th className='text-center' style={{width:'120px'}}>{messages['Department']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Work Date']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Work Time']}</th>
  	          <th className='text-center' style={{width:'120px'}}>{messages['Work Type']}</th>
  	          <th className='text-center' style={{width:'200px'}}>{messages['Detail']}</th>
  	        </tr>
  	      </thead>
  	      <tbody>
  	        {this.renderRowData()}
  	      </tbody>
  	    </table>
  	  </div>
  	)
  }

  render() {
  	let {loading} = this.state
  	return(
  	  <Box loading={loading}>
        <Box.Header border={true}>
          {this.props.messages['Technician Schedule']}
	      </Box.Header>
        <Box.Body>
          {this.renderTable()}
        </Box.Body>
      </Box>  
  	)
  }
} 

export default WorkTimeRecord = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.WorkTimeRecord}),null,null,{withRef:true}
)(WorkTimeRecord);


// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/WorkTimeRecord.js